import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import AGN_Wallpaper from '../Media/AGN_Wallpaper.jpg'



class Projects extends React.Component {

    render() {
        return (
            <div className='home'>

                <h2>Ground-Based Optical Observations of Exoplanet Candidates</h2>
                <p>
                Throughout my graduate career, preceding and in addition to my dissertation work, I worked on exoplanet observing. Until Sept 2017, research at the GMU Observatory’s 0.8m telescope, was run by a group of graduate students without the guidance of a professor (due to well established student interest, an observational exoplanet professor was hired thereafter).  We observed exoplanet transit candidates and qualified the GMU Observatory for the KELT Follow Up Network. We reduce the data to produce light curves in AstroImageJ. We distinguished, for example whether the candidates were hot Jupiter exoplanets or brown dwarf companion stars. We also took observations of microlensing exoplanet candidates for the OGLE Collaboration, confirming that such observations are possible from our latitude.  These were excellent projects to involve both graduate and undergraduate students in with varying backgrounds and levels of supervision.  Several promising careers were launched from exoplanet research at the GMU Observatory.  Since joining Tel Aviv University, I won 44 nights of observing time on the 0.7m telescope, for use in exoplanet transit candidate monitoring as the corresponding member of the KELT Follow-Up Network and the TESS Follow-up Observing Program (SG1), at the Wise Observatory.  The KELT work has so far resulted in a published catalogue of False Positive signals, which reduces wasted time for TESS.  
                </p>


            </div>
        );
    }
}

const styles = theme => ({
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing.unit * 4,
    backgroundColor: theme.palette.background.default,
  },
  img: {
    display: 'block',
    overflow: 'hidden',
    width: '100%',
  },
});

Projects.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Projects);



// WEBPACK FOOTER //
// ./src/Components/Exoplanets.js